import module from 'viaticos/module.js'

export const schema = {
  fecha_pago: 'date',
  pendiente: 'boolean',
  status_pagado: 'boolean',
  importe: 'number',
  tipo_cambio: 'number',
}

export class ViaticosPagosPagoPagarService {
  constructor ($http) {
    this.$http = $http
  }

  post (folio, indice, pago) {
    return this.$http.post('api/viaticos/viaticos/pagos/pago/pagar', pago, {
      params: {
        folio: folio,
        indice_anticipo: indice,
      },
      schema,
    })
  }
}

module.service('ViaticosPagosPagoPagarService', ViaticosPagosPagoPagarService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Pagos/Pago/Pagar.js